// 职业规划聊天记录
import React from 'react';
import Masonry from 'react-masonry-css';

import Config from '../../config/Config';

class WaterfallCard extends React.Component 
{
    constructor( props )
    {
        super(props);

        this.state = {
            sourcePath: Config.getSourcePath(),
        }
    }

    notify = ( item ) => {

        if( this.props.notify )
        {
            this.props.notify(item);
        }
    }   

    render()
    {
        const { data, breakpointColumnsObj = { default: 3} } = this.props;

        const { sourcePath } = this.state; 

        return ( 
            <div className='sf-career-waterfall-card' >
                <Masonry 
                    breakpointCols={breakpointColumnsObj}
                    className="sf-career-waterfall-card-row"
                    columnClassName="sf-career-waterfall-card-column" >
                {
                    data.map((item, index) => {
                        return (
                            <div className='sf-career-waterfall-card-item' key={index + item.key} onClick={ () => {this.notify(item)} }>
                                <div  className='sf-career-waterfall-card-icon' ><img src={require('./../../img/' + sourcePath + '/career/' + item.img)}></img></div>
                                <div className='sf-career-waterfall-card-item-row'> 
                                    <div className='sf-career-waterfall-card-item-row-body'>
                                        <div className='sf-career-waterfall-card-item-title'>{item.title}</div>
                                        <div className='sf-career-waterfall-card-item-date'>
                                            <span>{item.time}</span>
                                        </div>
                                    </div>
                                    <div className='sf-career-waterfall-card-item-description'>{item.description}</div>
                                    <div className='sf-career-waterfall-card-item-status'>
                                        <img src={require('./../../img/' + sourcePath + '/career/user.png')}></img>
                                        <span>{item.status}</span>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
                </Masonry>
            </div>
        )
    }
}

export default WaterfallCard